import { Grid } from '@mui/material';

import { SettingsHeader } from '../../components/SettingsHeader';
import SettingsIndex from '../../components/SettingsIndex';
import { IOption } from '../../components/SettingsIndex/SettingsIndex';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import { lazyImport } from '../../utils/lazyImport';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

const { CareerPageSettingChildRoutes } = lazyImport(
  () => import('./childRoutes'),
  'CareerPageSettingChildRoutes'
);
const CareerPageSettingsLayout = () => (
  <Grid container>
    <Grid item xl={12} lg={12} md={12}>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.CAREER_PAGES,
          Pages['CAREER_PAGE_SETTINS']
        )}
      />
      <SettingsHeader title="Career Page Settings" />
    </Grid>
    <Grid item xl={3} lg={3} md={3}>
      <SettingsIndex index={'   '} options={sideMenuOptions} />
    </Grid>
    <Grid item xl={9} lg={9} md={9} my={4}>
      <CareerPageSettingChildRoutes />
    </Grid>
  </Grid>
);

const sideMenuOptions: IOption[] = [
  {
    label: 'General',
    url: '/app-settings/career-page/general',
  },
  {
    label: 'Appearance',
    url: '/app-settings/career-page/appearance',
  },
  {
    label: 'Jobs',
    url: '/app-settings/career-page/job-settings',
  },
  {
    label: 'Candidates',
    url: '/app-settings/career-page/candidate',
  },
  {
    label: 'Email',
    url: '/app-settings/career-page/email',
  },
  {
    label: 'Integration',
    url: '/app-settings/career-page/integration',
  },
  {
    label: 'Widget Script',
    url: '/app-settings/career-page/widget',
  },
];

export default CareerPageSettingsLayout;
